import type { FC } from "react"
import { useCallback, useState, useEffect } from "react"
import classNames from "classnames"
import ResizeObserver from "rc-resize-observer"
import { useControllerModel } from "@/models"
import wayzIcon from "@/assets/header/wayzai.png"
import { createSVGIcon, svgToDataURL } from "@/components/Header/createSvg"
import { getClientSize, getHeaderContentWidth } from "@/util/commonUtils"
import "./index.scss"
// ==============================================
interface TopDecorationProps {
  // 名称
  showName: string
  // 获取left
  getMenuLeft?: (left: number) => void
}
const TopDecoration: FC<TopDecorationProps> = ({ showName, getMenuLeft }) => {
  const { theme } = useControllerModel()
  const [logoUrl, setLogoUrl] = useState<string>("")

  // resize
  const headerResize = useCallback(() => {
    const { clientWidth = 1920 } = getClientSize()
    const textWidth = getHeaderContentWidth(showName) || 80
    const titleWidth = 200 + textWidth
    const logoUrl = svgToDataURL(createSVGIcon(clientWidth, titleWidth))
    const left = (titleWidth < 360 ? 360 : titleWidth) + (theme === "dark" ? 30 : 0)

    setLogoUrl(logoUrl)
    // 获取left
    getMenuLeft?.(left)
  }, [setLogoUrl, showName, theme, getMenuLeft])

  // showName变动时调用
  useEffect(() => {
    // resize
    headerResize()
  }, [headerResize])

  return (
    <ResizeObserver onResize={headerResize}>
      <div className={classNames("top-decoration", `top-decoration-${theme}`)}>
        {theme === "dark" && <img src={logoUrl} alt="" />}
        <img className="decoration-icon" src={wayzIcon} />
        <span className="decoration-name pangmen">{showName}</span>
      </div>
    </ResizeObserver>
  )
}

export default TopDecoration
